import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tmtt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve stored image references (uploaded files come back as /api/files/...)
export const resolveImg = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
  return url;
};
